import { Button } from '@/components/ui/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

export const ChangeChanelRequestSchema = z.object({
  channelNumber: z.string().nonempty('Channel number is required'),
});

export type ChangeChanelRequest = z.infer<typeof ChangeChanelRequestSchema>;

export function ChangeChannelForm({ onSubmit, onChancel }: any) {
  const form = useForm<ChangeChanelRequest>({
    resolver: zodResolver(ChangeChanelRequestSchema),
    defaultValues: {
      channelNumber: '',
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
        <FormField
          control={form.control}
          name="channelNumber"
          render={({ field, fieldState }) => (
            <FormItem>
              <FormLabel>Channel</FormLabel>
              <FormControl>
                <Input
                  autoComplete="off"
                  inError={!!form.formState.errors.channelNumber}
                  placeholder="Channel number"
                  {...field}
                />
              </FormControl>
              <FormMessage>{fieldState.error?.message || ''}</FormMessage>
            </FormItem>
          )}
        />

        <div className="flex gap-4 justify-end">
          <Button type="button" variant="outline" onClick={onChancel}>
            Cancel
          </Button>
          <Button type="submit">Submit</Button>
        </div>
      </form>
    </Form>
  );
}
